import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Immutable from 'immutable'
import { compareMoments as ascOrderComparator } from 'utils/deliveries'
import Order from './Order'
import { NoOrders } from './NoOrders'
import { Fire5RecipeAwarenessTracking } from './Fire5RecipeAwarenessTracking/Fire5RecipeAwarenessTracking'

const OrdersList = ({ orders }) => {
  // OrdersList component always renders items in the ASCending order
  const orderedList = useMemo(() => orders.toList().sortBy(
    (value) => moment(value.get('deliveryDay')),
    ascOrderComparator
  ), [orders])

  return (
    <div>
      <Fire5RecipeAwarenessTracking orders={orders} />
      {orders.size < 1 ? <NoOrders /> : null}
      {orderedList.map((order) => (
        <Order key={order.get('id')} order={order} />
      ))}
    </div>
  )
}

OrdersList.propTypes = {
  orders: PropTypes.instanceOf(Immutable.Map),
}

OrdersList.defaultProps = {
  orders: Immutable.fromJS({}),
}

export default OrdersList
